import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-claims-payment-breakup',
  templateUrl: './claims-payment-breakup.component.html',
  styleUrls: ['./claims-payment-breakup.component.scss']
})
export class ClaimsPaymentBreakupComponent implements OnInit {
  _currentComponentName = "ClaimsPaymentBreakupComponent"

  constructor(private viewContainerRef: ViewContainerRef,
    public validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService) { }

  //Declaraions which might need developer input
  claimsPaymentBreakupForm: FormGroup
  CLAIMSPAYMENTBREAKUPFORMNAME = "claimsPaymentBreakupForm"
  lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd']
  selectorOfThisComponent = 'app-claims-basic-details'
  parentEvent$
  dataSet

  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() transactionState: any;
  @Input() IO: any;
  private _inputDataForEdit = null;

  @Input()
  set inputDataForEdit(value: any) {
    if (value) {
      this._inputDataForEdit = value;
    }
    else {
      this._inputDataForEdit = []
    }
    this.claimPaymentDOs = this.commonUtilty.searchAndStitchClientDO(this._inputDataForEdit, this.IO)
  };

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
        let isOutputValid = this.validateOutput(this.claimsPaymentBreakupForm)
        if (isOutputValid)
          this.EmitComponentOutput(this.claimPaymentDOs)
        else {
          this.EmitComponentOutput("ERROR")
        }
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }

  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle)
      console.groupEnd();
    }
    if (this._inputDataForEdit != null) this.initializeClientSearchForm(this._inputDataForEdit)
    this.subscribeToParentEvent()
    this.subscribeToAddNominee();
  }



  /**
   * Form Trasactions
   */

  initializeClientSearchForm(data?) {
    let payload = data || {}
    this.claimsPaymentBreakupForm = this.fb.group({

    });
  }

  isRequired(fieldName) {
    let returnObj = this.validationUtilService.isRequired(fieldName, this.CLAIMSPAYMENTBREAKUPFORMNAME)
    return returnObj
  }



  claimPaymentDOs: any;
  nomineeListSubject$
  subscribeToAddNominee() {
    if (this.nomineeListSubject$)
      this.nomineeListSubject$.unsubscribe()
    this.nomineeListSubject$ = this.interactService.payeeListSubject$.subscribe(res => {
      if (res && res.length) {
        this.claimPaymentDOs = this.commonUtilty.refreshPayeeList(this.claimPaymentDOs, res);
      }
    })
  }

  
}


